import { ClientResponse } from '@commercetools/platform-sdk';

import { ctApi } from '@/api';
import {
  CustomProductProjectionSearch,
  CustomProductProjectionSearchResponse,
  SearchByCustomProductKeyVariables,
} from '@/graphql/customProducts';
import {
  NutsProductProjection,
  NutsProductProjectionDisplayVariant,
} from '@/utils/productProjection';

export async function getBundleParentLookup(): Promise<NutsProductProjectionDisplayVariant> {
  const response = (await ctApi
    .graphql()
    .post({
      body: {
        query: CustomProductProjectionSearch,
        variables: {
          customProductKey: ['Dynamic Bundle'],
        } satisfies SearchByCustomProductKeyVariables,
      },
    })
    .execute()) as unknown as ClientResponse<CustomProductProjectionSearchResponse>;

  const { results } = response.body.data.productProjectionSearch;
  const productProjections = results.map((result) => {
    const productProjection = NutsProductProjection.fromQueryResult(result);
    return NutsProductProjection.toDisplayVariant(productProjection);
  });
  const result = productProjections.find((projection) => !projection.variant.backordered);
  if (!result) {
    throw new Error('No bundle parent lookup found');
  }
  return result;
}
